import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import buildImageUrl from '../../../../lib/media-url-maker'
import OfferCarouselLarge from './OfferCarouselLarge'
import OfferCarouselPreview from './OfferCarouselPreview'
import theme from '../../../theme'

const CarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in-out;
  background: ${theme.colors.blue_light};
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const TransitionWrapper = styled.div`
  animation: ${fadeIn} 0.3s ease-in-out;
`

const OfferCarouselWidget = ({ items = [] }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)

  items = items.map((item) => {
    item.src =
      item.images &&
      item.images.widgets &&
      item.images.widgets.length &&
      buildImageUrl({
        width: 1200,
        mode: 'cover',
        resource:
          item.images.widgets[0].crops &&
          item.images.widgets[0].crops[0] &&
          item.images.widgets[0].crops[0].src
      })

    item.previewSrc =
      item.previewImages &&
      item.previewImages.widgets &&
      item.previewImages.widgets.length &&
      buildImageUrl({
        width: 600,
        mode: 'cover',
        resource:
          item.previewImages.widgets[0].crops &&
          item.previewImages.widgets[0].crops[0] &&
          item.previewImages.widgets[0].crops[0].src
      })

    return item
  })

  const handleOpen = (index) => {
    setSelectedIndex(index)
    setIsOpen(true)
  }

  return (
    <CarouselWrapper>
      {isOpen ? (
        <TransitionWrapper>
          <OfferCarouselLarge initialIndex={selectedIndex} items={items} />
        </TransitionWrapper>
      ) : (
        <OfferCarouselPreview items={items} handleOpen={handleOpen} />
      )}
    </CarouselWrapper>
  )
}

export default OfferCarouselWidget
